import React from 'react';
import styles from './button-secondary.module.css';

const ButtonSecondary = ({
	text,
	onClick,
	extraStyle,
	styleStyle,
	// extraTextStyle,
	disabled,
}) => (
	<button
		className={`${styles.container} ${extraStyle} ${disabled ? styles.disabled : ''}`}
		onClick={() => !disabled && onClick()}
		style={styleStyle}
	>
		{text}
	</button>
);

export default ButtonSecondary;
